import React, { useCallback } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import { mapCandidateAttachments } from 'features/sendouts/common/utils';
import { Attachments } from 'features/sendouts/components/shared';
import { AttachmentsVariant } from 'features/sendouts/components/shared/Attachments';
import { TabLoaderContainer } from 'features/sendouts/components/shared/DetailsTabs';
import { ATTACHMENTS_CATEGORIES } from 'features/sendouts/constants';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import strings from 'strings';
import { CandidateFileCategoriesWithSendout } from 'UI/components/organisms/sendouts/utils';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';
import { Endpoints } from 'UI/constants/endpoints';

import { SectionContainer } from './SendoutAttachmentsTabContent.styled';

const ATTACHMENT_CATEGORIES = [
  ATTACHMENTS_CATEGORIES.resume,
  ATTACHMENTS_CATEGORIES.portfolio,
  ATTACHMENTS_CATEGORIES.other
];

export const SendoutAttachmentsTabContent = ({ sendoutId }) => {
  const { Status } = useFetchWithStatusV2({
    endpoint: sendoutId
      ? `${Endpoints.SendoutAttachments.replace(':id', sendoutId)}?includes=fileType`
      : null,
    apiVersion: 2
  });

  const renderAttachments = data => {
    const attachments = mapCandidateAttachments(data);

    return (
      <>
        <SectionContainer>
          <Typography variant="subtitle1">
            {strings.sendoutsV2.drawers.tabs.attachments.sendoutFiles}
          </Typography>
          <Attachments
            allowDelete={false}
            categories={ATTACHMENT_CATEGORIES}
            categoryIdMap={CandidateFileCategoriesWithSendout}
            files={attachments}
            variant={AttachmentsVariant.Readonly}
          />
        </SectionContainer>
      </>
    );
  };

  return (
    <Status
      loading={
        <TabLoaderContainer>
          <CircularProgress />
        </TabLoaderContainer>
      }
      success={renderAttachments}
      empty={renderAttachments([])}
      error={<EmptyPlaceholder title={strings.sendoutsV2.drawers.tabs.status.error} />}
    />
  );
};
